import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import SspContext from '../../contexts/SspContext'
import CardTransactions from './CardTransactions/CardTransactions'
import DepositTransactions from '../../containers/Home/Account/DepositTransactions/DepositTransactions'
import { useTransactions } from '../../hooks/useTransactions'

import './Transactions.scss'
import TransactionsContext, {
	TransactionsContextProvider,
} from 'selfServicePortal/contexts/TransactionsContext'
import { SkeletonLoader } from './SkeletonLoader/SkeletonLoader'

const TransactionsComponent = () => {
	const { t } = useTranslation()
	const { component, isCard } = useContext(SspContext)
	const { transactions, errorTransactions } = useContext(TransactionsContext)
	//const [transactionsComponent, setTransactionsComponent] = useState(<></>)
	const isOverview = component?.title === 'Overview'

	const { error } = useTransactions()

	// useEffect(() => {
	// 	if (isCard?.isCard) {
	// 		setTransactionsComponent(
	// 			<CardTransactions isOverview={isOverview} />,
	// 		)
	// 	} else {
	// 		setTransactionsComponent(
	// 			<DepositTransactions isOverview={isOverview} />,
	// 		)
	// 	}
	// 	// eslint-disable-next-line
	// }, [isCard])

	const transactionsComponent = isCard?.isCard ? (
		<CardTransactions isOverview={isOverview} />
	) : (
		<DepositTransactions isOverview={isOverview} />
	)

	return (
		<React.Fragment>
			{errorTransactions ? (
				<div className="container mt-3 error-msg">{t('ErrorMsg')}</div>
			) : (
				<>
					{error ? (
						<div className="container mt-3">{t(error.message)}</div>
					) : (
						<React.Fragment>
							{transactions === undefined ||
							transactions?.length <= 0 ? (
								<SkeletonLoader />
							) : (
								transactionsComponent
							)}
						</React.Fragment>
					)}
				</>
			)}
		</React.Fragment>
	)
}

const Transactions = () => {
	return (
		<TransactionsContextProvider>
			<TransactionsComponent />
		</TransactionsContextProvider>
	)
}
export default Transactions
